module.exports = __webpack_public_path__ + "images/2.1788773129009.jpg";